var staticHGKeyRE = /(.+)?\[(\d+)\]$/

module.exports = staticHGKeyRE



//////////////////
// WEBPACK FOOTER
// ./node_modules/xe-utils/methods/static/staticHGKeyRE.js
// module id = mXIE
// module chunks = 94